import { Form, Input } from "antd";
import React, { ReactNode } from "react";
import { LoginSignupFormType } from "../../../../Utils/Constants/loginSignupFormTypes";
import "./index.css";

interface IPinInputComponentProps {
  onChange?: (event: string) => void;
  className?: string;
  label?: string;
  id?: string;
  enterPressed?: () => void;
  nameField?: string;
  customRule?: any;
  addonBefore?: ReactNode;
}

const PinInputComponent: React.FC<IPinInputComponentProps> = ({
  className,
  label,
  id,
  enterPressed,
  onChange,
  nameField,
  customRule,
  addonBefore,
}) => {
  const onPasswordChange = (e: any) => {
    e.target.value = e.target.value.replace(/[^0-9!@#$%&*a-zA-Z]/g, "");
  };

  const pinValidator = (_: any, value: string) => {
    const passwordRegex =
      /^(?=.*\d)(?=.*[!@#$%&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/;

    if (!passwordRegex.test(value))
      return Promise.reject(
        new Error(
          "Password must have at least 8 characters. (1 number, 1 special character (!, @, #, $, %, &, *), 1 uppercase character, 1 lowercase character)"
        )
      );
    return Promise.resolve();
  };

  return (
    <Form.Item
      className={`${className} formItemMarginBotton`}
      name={nameField ? nameField : LoginSignupFormType.pin}
      rules={[
        {
          required: true,
          message: "* Required field",
        },
        {
          validator: customRule,
        },
        {
          validator: pinValidator,
        },
      ]}
    >
      <Input.Password
        addonBefore={addonBefore}
        type="tel"
        autoComplete="off"
        id={id}
        inputMode="text"
        minLength={8}
        placeholder={label ? label : "Enter Password"}
        onPressEnter={enterPressed}
        onInput={onPasswordChange}
        onChange={(event: any) => onChange && onChange(event.target.value)}
        className="formItemPinInput"
      />
    </Form.Item>
  );
};

export default PinInputComponent;
